export default {
      id: "common__pin_disabled-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__pin_disabled",
      toString: function () {
        return this.url;
      }
    }